const NAV_LEFT = ['WORKS', 'ABOUT', 'JOURNAL', 'CONTACT'];

export default function HeroNav() {
  return (
    <nav className="w-full px-6 md:px-10 pt-6 md:pt-7 font-mono text-[11px] tracking-[0.12em] text-foreground-950">
      <div className="grid grid-cols-12 items-center gap-4">
        {/* Left menu */}
        <div className="col-span-12 md:col-span-6 flex flex-wrap items-center gap-x-5 gap-y-2">
          {NAV_LEFT.map((item) => (
            <a
              key={item}
              href={`#${item.toLowerCase()}`}
              className="cursor-pointer whitespace-nowrap hover:opacity-60 transition-opacity"
            >
              {item}
            </a>
          ))}
        </div>

        {/* Center brand */}
        <div className="hidden md:flex md:col-span-3 justify-center">
          <a
            href="#"
            className="cursor-pointer whitespace-nowrap font-semibold tracking-[0.18em] hover:opacity-60 transition-opacity"
          >
            LIMUNASPHERE®
          </a>
        </div>

        {/* Right contact */}
        <div className="hidden md:flex md:col-span-3 justify-end">
          <a
            href="mailto:hello@lumishere.com"
            className="cursor-pointer whitespace-nowrap hover:opacity-60 transition-opacity"
          >
            HELLO@LUMISHERE.COM
          </a>
        </div>
      </div>
    </nav>
  );
}